import { AType, summon } from "@silversea-ssc/functional-support"
import { PriceRequestV2 } from "./request"
import { PriceErrorCode } from "./error-code"

// TODO - review errors: build type with GenericErrorResponse
export const PriceErrorResponseV2 = summon((F) =>
    F.interface(
        {
            request: PriceRequestV2(F),
            errorCode: PriceErrorCode(F),
        },
        "PriceErrorResponseV2",
    ),
)
export type PriceErrorResponseV2 = AType<typeof PriceErrorResponseV2>
